import { render, staticRenderFns } from "./QuizMessage.vue?vue&type=template&id=425e41fd&"
import script from "./QuizMessage.vue?vue&type=script&lang=js&"
export * from "./QuizMessage.vue?vue&type=script&lang=js&"
import style0 from "./QuizMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports